import React from "react";
import { Modal, Alert, AlertTitle } from "@mui/material";

export default function MessageModal(props) {
    return (
        <>
            <Modal open={props.open} onClose={props.onClose}>
                <Alert severity={props.severity}>
                    <AlertTitle>{props.title}</AlertTitle>
                    {props.children}
                </Alert>
            </Modal>
        </>
    );
}
